import { Box, Button } from '@material-ui/core';
import { Typography } from '@mui/material';
import React from 'react';
import { ErrorIcon } from './ErrorIcon';
import Erro500Component from '500Error';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    console.log('error', this.state);
    if (this.state.error || this.state.errorInfo) {
      if (
        this.state?.error?.message?.includes('500') ||
        this.state?.error?.stack?.includes('500')
      ) {
        return <Erro500Component />;
      }
      // Error path
      return (
        <Box
          sx={{
            width: '100%',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            padding: '3rem',
            gap: '10px'
          }}
        >
          <img
            onClick={() => (window.location.href = '/dashboard')}
            src='https://res.cloudinary.com/dgny8sjrg/image/upload/v1638786088/Bizedge_Frontend_Assets/Bizedge_logo_axcwlg.svg'
            alt='bizedge logo'
            style={{ width: '135.11px', height: '33.74px', cursor: 'pointer' }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '25px',
              marginTop: '10rem'
            }}
          >
            <ErrorIcon />
            <Typography
              sx={{
                fontFamily: 'Black Sans',
                fontWeight: 700,
                fontSize: '50px',
                lineHeight: '89.83%',
                color: '#878787'
              }}
            >
              Oops!
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Black Sans',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: 'normal',
                width: '50%',
                textAlign: 'center',
                color: '#878787'
              }}
              variant='subtitle2'
            >
              Something went wrong. It may be your network, please refresh and
              try again. If problem persists, please{' '}
              <a
                href='https://bizedgeapp.com/contact-us'
                target='_blank'
                rel='noreferrer'
                className='text-[#2898A4]'
              >
                contact support.
              </a>
            </Typography>
            <Button
              variant='contained'
              style={{
                backgroundColor: '#2898A4',
                color: 'white',
                width: '190px',
                height: '32px',
                borderRadius: '4px'
              }}
              color='black'
              onClick={() => window.location.reload()}
            >
              <strong> Refresh</strong>
            </Button>
          </Box>
        </Box>
      );
    }

    // Normally, just render children
    return this.props.children;
  }
}
